// 协议管理
import http from "@/jslibs/axios/http";

// 协议查询
export const detail = (data) => http.post("/web/contentManager/getAgreement", data);

// 协议更新
export const edit = (data) => http.post("/web/contentManager/updateAgreement", data);